export function createGoogleMapOverlayClass(google) {
    return class GoogleMapOverlayFactory extends google.maps.OverlayView {
        constructor(mapInstance) {
            super();
            this.ready = false;
            this.setMap(mapInstance);
        }

        onAdd() {
            // Optional: DOM-Elemente hinzufügen
        }

        draw() {
            if (!this.ready) {
                this.ready = true;
                google.maps.event.trigger(this, 'ready');
            }
        }

        onRemove() {
            // Optional: DOM-Elemente entfernen
        }

        remove() {
            this.setMap(null);
        }

        getProjectionInstance() {
            return this.getProjection(); // kann null sein, bis ready
        }
    }
}